<template>
  <div> <!-- 여기까지 page header 이하 수정해서 사용-->
    <div class='applicant-grid'>
      <dx-data-grid ref='refPositionGrid'
        :data-source='applicantInfoList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :row-alternation-enabled="true"
        height="220" keyExpr="seqId" :focusedRowEnabled="true" :focused-row-key.sync='focusedRowKey'
        :auto-navigate-to-focused-row="true" @focused-row-changed="onFocusedRowChanged"
        @editor-preparing='onEditorPreparing' @toolbarPreparing="onToolbarPreparing"
        @row-removed='onRowRemoved' @row-inserted='onRowInserted' @row-inserting='onRowInserting'
        @row-updated='onRowUpdated' @row-updating='onUpdating'
        @init-new-row='onInitNewRow'
        @cellPrepared="onCellPreparedMain"
        @cellClick="onCellClick"
      >
        <DxSearchPanel
          :visible="false"
          placeholder="검색..."
        />
        <DxExport
          :enabled="false"
        />
        <DxFilterRow
          :visible="false"
          apply-filter="auto"
        />
        <DxEditing
          :allow-deleting="isCRUD"
          :allow-updating="isCRUD"
          :allow-adding="true"
          :use-icons="true"
          mode='row'
        >
        </DxEditing>
        <DxColumnFixing :enabled="true"/>
        <DxColumn
          :allowEditing="true"
          :visible="true"
          caption="후보ID"
          data-field="지원자코드"
          format="#,##0"
          dataType="number"
          :min-width="60"
          :fixed="true"
          alignment="center"
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          :visible="true"
          caption="진행단계"
          data-field="추천진행단계"
          alignment="center"
          :min-width="80"
          :fixed="true"
        >
          <DxRequiredRule message="항목을 입력하세요"/>
          <DxLookup
            :data-source="processingLookup"
            display-expr="코드명"
            value-expr="코드명"
          />
        </DxColumn>
        <DxColumn
        :allowEditing="isIdEdit"
        :visible="true"
        caption="성명"
        data-field="성명"
        alignment="center"
        :min-width="80"
        edit-cell-template="applicantGridTemplate"
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          :visible="true"
          caption="계약연봉(원)"
          data-field="계약연봉"
          format="#,##0"
          dataType="number"
          :min-width="100"
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          :visible="true"
          caption="합격일"
          data-field="합격일"
          alignment="center"
          format="yyyy-MM-dd"
          dataType="date"
          :min-width="100"
          >
        </DxColumn>
        <DxColumn
        :allowEditing="true"
        :visible="true"
        caption="탈락사유"
        data-field="탈락사유"
        alignment="center"
        :min-width="120"
        >
        </DxColumn>

        <DxColumn
        :allowEditing="false"
        :visible="true"
        caption="성별"
        data-field="성별"
        alignment="center"
        :min-width="60"
        >
          <DxLookup
            :data-source="manWoomanLookup"
            display-expr="코드명"
            value-expr="코드명"
          />
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="isExporing"
        caption="생년월일"
        data-field="생년월일"
        alignment="center"
        format="yyyy-MM-dd"
        dataType="date"
        :min-width="100"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="true"
        caption="나이"
        :calculate-cell-value="calculateAge"
        dataType="number"
        :min-width="60"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="isExporing"
        caption="최종학력"
        data-field="최종학력"
        alignment="center"
        :min-width="80"
        >
          <DxLookup
            :data-source="studyLookup"
            display-expr="코드명"
            value-expr="코드명"
          />
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="isExporing"
        caption="졸업여부"
        data-field="졸업여부"
        alignment="center"
        :min-width="100"
        >
          <DxLookup
            :data-source="graduateLookup"
            display-expr="코드명"
            value-expr="코드명"
          />
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="true"
        caption="최종학교명"
        data-field="최종학교명"
        alignment="left"
        :min-width="100"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="isExporing"
        caption="학교소재지"
        data-field="학교소재지"
        alignment="left"
        :min-width="100"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="isExporing"
        caption="전공"
        data-field="전공"
        alignment="center"
        :min-width="80"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="isExporing"
        caption="부전공"
        data-field="부전공"
        alignment="center"
        :min-width="80"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="isExporing"
        caption="입학년도"
        data-field="입학년도"
        alignment="center"
        dataType="number"
        :min-width="80"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="isExporing"
        caption="졸업년도"
        data-field="졸업년도"
        alignment="center"
        dataType="number"
        :min-width="80"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="true"
        caption="경력연수"
        data-field="경력연수"
        format="#,##0"
        dataType="number"
        :min-width="60"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="isExporing"
        caption="최종회사명"
        data-field="최종회사명"
        alignment="left"
        :min-width="100"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="isExporing"
        caption="직위"
        data-field="직위"
        alignment="center"
        :min-width="80"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="isExporing"
        caption="대표회사"
        data-field="대표회사"
        alignment="left"
        :min-width="100"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="isExporing"
        caption="현재연봉(천)"
        data-field="현재연봉"
        format="#,##0"
        dataType="number"
        :min-width="100"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="isExporing"
        caption="희망연봉(천)"
        data-field="희망연봉"
        format="#,##0"
        dataType="number"
        :min-width="100"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="isExporing"
        caption="외국어1"
        data-field="외국어1"
        alignment="center"
        :min-width="80"
        >
          <DxLookup
            :data-source="languageLookup"
            display-expr="코드명"
            value-expr="코드명"
          />
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="isExporing"
        caption="외국어1등급"
        data-field="외국어1등급"
        alignment="center"
        :min-width="60"
        >
          <DxLookup
            :data-source="levelLookup"
            display-expr="코드명"
            value-expr="코드명"
          />
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="isExporing"
        caption="외국어2"
        data-field="외국어2"
        alignment="center"
        :min-width="80"
        >
          <DxLookup
            :data-source="languageLookup"
            display-expr="코드명"
            value-expr="코드명"
          />
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="isExporing"
        caption="외국어2등급"
        data-field="외국어2등급"
        alignment="center"
        :min-width="60"
        >
        <DxLookup
          :data-source="levelLookup"
          display-expr="코드명"
          value-expr="코드명"
        />
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="isExporing"
        caption="자격증1"
        data-field="자격증1"
        alignment="center"
        :min-width="110"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="isExporing"
        caption="자격증2"
        data-field="자격증2"
        alignment="center"
        :min-width="110"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="isExporing"
        caption="자격증3"
        data-field="자격증3"
        alignment="center"
        :min-width="110"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="true"
        caption="컨설턴트"
        data-field="컨설턴트"
        alignment="center"
        :min-width="80"
        >
          <DxLookup
            :data-source="employeeInfo"
            display-expr="성명"
            value-expr="사번"
          />
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="true"
        caption="추천인"
        data-field="createdId"
        alignment="center"
        :min-width="80"
        >
          <DxLookup
            :data-source="employeeInfo"
            display-expr="성명"
            value-expr="사번"
          />
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="true"
        caption="등록일"
        data-field="createdTime"
        alignment="center"
        format="yyyy-MM-dd"
        dataType="date"
        :min-width="100"
        >
        </DxColumn>
        <!-- <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            show-in-column="성명"
            display-format="{0} (건)"
          />
        </DxSummary> -->
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multi"/>
        <template #position-title>
          <div class="toolbar-label" style="font-size:1.1rem;margin-left:4px;">
            {{dataSource.포지션제목}} - 추천현황
          </div>
        </template>
        <template #applicantGridTemplate="{ data: cellInfo }" >
          <ApplicantGridComponent
            :value="cellInfo.value"
            :on-value-changed="cellInfo.setValue"
            @change-selected="onChangedApplicant"
          />
        </template>
      </dx-data-grid>
    </div>
  </div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import DxDataGrid, { DxFilterRow, DxExport, DxColumnFixing, DxPaging, DxScrolling,
  DxColumn, DxSorting, DxEditing, DxSearchPanel, DxLookup } from 'devextreme-vue/data-grid'
import { DxRequiredRule } from 'devextreme-vue/validator'
import ApplicantGridComponent from '../../share/component/devextream-template/ApplicantGridComponent'

export default {
  name: 'applicantComponent',
  data: function () {
    return {
      isLoading: false,
      userInfo: this.$store.getters.getUserInfo,
      applicantInfoList: null,
      focusedRowKey: null,
      selectedRow: null,
      processingLookup: this.$store.getters.getBaseDataByType(ConstDef.지원자진행단계),
      studyLookup: this.$store.getters.getBaseDataByType(ConstDef.최종학력),
      manWoomanLookup: ConstDef.남녀,
      graduateLookup: ConstDef.졸업여부,
      levelLookup: ConstDef.상중하,
      languageLookup: this.$store.getters.getBaseDataByType(ConstDef.외국어능력),
      employeeInfo: this.$store.getters.getEmployee,
      isExporing: false,
      selectedNewApplicant: null,
      isIdEdit: true
    }
  },
  props: {
    dataSource: {
      type: Object,
      default: null
    }
  },
  components: {
    DxDataGrid,
    DxExport,
    DxFilterRow,
    DxPaging,
    DxColumnFixing,
    DxColumn,
    DxSorting,
    DxEditing,
    DxRequiredRule,
    DxSearchPanel,
    DxLookup,
    DxScrolling,
    ApplicantGridComponent
  },
  created () {
    // console.log(this.processingLookup)
  },
  mounted () {
    this.refreshApplicant()
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calculateAge (row) {
      if (row.생년월일 !== undefined) {
        return parseInt(this.$_appLib.getToday().substring(0, 4)) - parseInt(row.생년월일.substring(0, 4))
      }
    },
    isCRUD (e) {
      return (e.row.data.컨설턴트 === this.userInfo.userId ||
        e.row.data.포지션등록자 === this.userInfo.userId ||
        this.userInfo.permission === ConstDef.SYSTEM_ADMIN)
    },
    onCellClick (e) {
      if (e.column.dataField === '지원자코드') {
        const url = `/main/applicant?seqId=${e.data.지원자코드}`
        window.open(url, '_blank')
        console.log(e)
      }
    },
    onCellPreparedMain (e) {
      if (
        e.rowType === 'data' &&
        (e.column.dataField === '지원자코드')
      ) {
        e.cellElement.style.color = 'blue'
        e.cellElement.style.textDecoration = 'underline'
        e.cellElement.style.cursor = 'pointer'
      }
    },
    onEditorPreparing (e) {
      if (e.dataField === '추천진행단계' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isIdEdit = true
        } else {
          this.isIdEdit = false
        }
      }
    },
    onFocusedRowChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
    },
    onInitNewRow (row) {
      row.data.추천진행단계 = ConstDef.등록완료
    },
    onRowInserted (row) {
      row.data.createdId = row.data.updatedId = this.userInfo.userId
      row.data.성명 = this.selectedNewApplicant.성명
      row.data.채용정보코드 = this.dataSource.seqId
      row.data.지원자코드 = this.selectedNewApplicant.seqId
      if (row.data.합격일 !== undefined && (typeof row.data.합격일) === 'object') {
        row.data.합격일 = this.$_appLib.formatDate(row.data.합격일.getTime())
      }
      // // console.log(row)
      this.$_sp.runInsertSqlProc('채용정보별지원자', ['seqId', '성명'], [row.data])
        .then(data => {
          this.refreshApplicant()
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowInserting (row) {

    },
    onRowRemoved (row) {
      this.$_sp.runDeleteSqlProc('채용정보별지원자', [{ seqId: row.data.seqId }])
        .then(data => {
          this.$snotify.info('삭제 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowUpdated (row) {
      // console.log(row.data)
      if (row.data.합격일 !== null && (typeof row.data.합격일) === 'object') {
        row.data.합격일 = this.$_appLib.formatDate(row.data.합격일.getTime())
      }
      const param = [
        {
          seqId: row.data.seqId,
          추천진행단계: row.data.추천진행단계,
          탈락사유: row.data.탈락사유,
          합격일: row.data.합격일,
          계약연봉: row.data.계약연봉,
          updatedId: this.userInfo.userId,
          메인회사수수료율: row.data.계약메인회사수수료율,
          코웍회사수수료율: row.data.계약코웍회사수수료율
        }
      ]
      // console.log(param)
      this.$_sp.runUpdateSqlProc('채용정보별지원자', ['seqId'], null, param)
        .then(data => {
          this.$snotify.info('변경 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onUpdating (row) {

    },
    onToolbarPreparing (e) {
      // // console.log(this.dataSource.포지션제목)
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: 'position-title'
        },
        {
          location: 'after',
          widget: 'dxCheckBox',
          options: {
            value: this.isExporing,
            text: '모든 컬럼 보기     ',
            focusStateEnabled: true,
            onValueChanged: (args) => {
              this.isExporing = args.value
            }
          }
        }
      )
    },
    refreshApplicant () {
      this.$_sp.runFindProc('spFindAllApplicantByPositionId', { positionId: this.dataSource.seqId })
        .then(data => {
          this.applicantInfoList = this.$_sp.MakeModel(data)
          console.log(this.applicantInfoList)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // 지원자 드롭박스
    onChangedApplicant (row) {
      // console.log(row)
      this.selectedNewApplicant = row
    }
  }
}
</script>

<style lang="scss">
.temp{
  color:#8b8b8b;
}
</style>
